import Component from '../../components/Component';
import Loading from '../../components/Loading';

import query from './query';
import { colors } from '../../lib/colors';

import React from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    BubbleController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    BubbleController,
);

/*
    Using ChartJs for show differnet type of charts
*/

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        this.isDark = !!JSON.parse(localStorage.getItem('dark-mode'));

        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ redraw: true, isDark });

        if (this.timeoutID) clearTimeout(this.timeoutID);

        this.timeoutID = setTimeout(() => {
            this.setState({ redraw: false });
        }, 100);
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        const { t } = this.props;

        const sortedData = this.state.data.sort((a, b) => {
            const aStartedNumber = Number(a.words.split(' ')[0]);
            const bStartedNumber = Number(b.words.split(' ')[0]);

            return aStartedNumber - bStartedNumber;
        });

        const data = Object.values(
            sortedData.reduce((acc, curr) => {
                if (!curr.words) return acc;

                if (acc[curr.words]) {
                    acc[curr.words].impressions = acc[curr.words].impressions + curr.impressions;
                    acc[curr.words].clicks = acc[curr.words].clicks + curr.clicks;

                    return acc;
                }

                acc[curr.words] = {
                    impressions: curr.impressions,
                    clicks: curr.clicks,
                    words: curr.words,
                    pages: curr.pages,
                };

                return acc;
            }, {}),
        ).sort((a, b) => a.words - b.words);

        const chartData = {
            labels: data.map((item) => item.words),
            datasets: [
                {
                    type: 'line',
                    label: t('discover.stats.discover.impression'),
                    data: data.map((item) => item.impressions),
                    backgroundColor: colors[0],
                    borderColor: colors[0],
                    yAxisID: 'y',
                    borderRadius: 4,
                    tension: 0.4,
                },
                {
                    type: 'line',
                    label: t('discover.stats.discover.clicks'),
                    data: data.map((item) => item.clicks),
                    backgroundColor: colors[1],
                    borderColor: colors[1],
                    yAxisID: 'y',
                    borderRadius: 4,
                    tension: 0.4,
                },
                {
                    type: 'bar',
                    label: t('discover.stats.discover.pages'),
                    data: data.map((item) => item.pages),
                    backgroundColor: colors[2],
                    borderColor: colors[2],
                    yAxisID: 'y1',
                    borderRadius: 4,
                    tension: 0.4,
                },
            ],
        };

        const isDark = this.state.isDark ?? this.isDark;

        const keys = {
            maintainAspectRatio: false,
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: t('discover.stats.discover.words'),
                    },
                    ticks: {
                        color: isDark ? '#959ca5' : '#777777',
                    },
                },
                y: {
                    type: 'logarithmic',

                    grid: {
                        display: false,
                    },
                    ticks: {
                        color: isDark ? '#959ca5' : '#777777',
                    },
                    title: {
                        display: true,
                        text: t('discover.stats.discover.y_title'),
                    },
                },
                y1: {
                    type: 'logarithmic',
                    display: true,
                    position: 'right',
                    grid: {
                        drawOnChartArea: false,
                    },
                    ticks: {
                        color: isDark ? '#959ca5' : '#777777',
                    },
                    title: {
                        display: true,
                        text: t('discover.stats.discover.y1_title'),
                    },
                },
            },
            interaction: {
                mode: 'nearest',
                intersect: false,
            },
            elements: {
                point: {
                    radius: 0, // invisible point
                    hitRadius: 10, // increase clickable area
                    hoverRadius: 6, // increase area for hover effect
                },
            },
            plugins: {
                legend: {
                    align: 'start',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rect',
                    },
                },
            },
            radius: 0,
        };

        return (
            <div
                className="Timeline"
                style={{ height: '100%', minHeight: '150px', position: 'relative' }}
            >
                <h3 className="box-header">{t('discover.stats.discover.header')}</h3>
                <small className="d-block card-sub-title text-muted  text-capitalize py-2">
                    {t('discover.stats.discover.subheader')}
                </small>
                <div
                    className="dt-exports d-flex justify-content-end w-100"
                    title="Refresh and clear cache"
                >
                    <button
                        className="dt-exports__button with-refresh"
                        type="button"
                        onClick={this.props.forceRun}
                        title="Refresh and clear cache"
                    >
                        <i className="icon-Frame-converted"></i>
                    </button>
                </div>
                {this.state.data[0] ? (
                    <div style={{ height: '400px', position: 'relative' }}>
                        <Chart data={chartData} options={keys} redraw={!!this.state.redraw} />
                    </div>
                ) : (
                    <div>{t('global.no_data')}</div>
                )}
            </div>
        );
    }
}

export default withTranslation()(Summary);
